// extracted by mini-css-extract-plugin
export default {"wrapper":"G9ntEhrymEQ_jPwTfy3v"};